import React, { useState, useEffect } from 'react';

// Components
import DownloadBtn_Win from './common/DownloadBtn_Win';
import DownloadBtn_Apple from './common/DownloadBtn_Apple';

// Icons
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';

//  Demo Videos
import demo_1 from '../util/videos/demo_1.mp4';
import demo_2 from '../util/videos/demo_2.mp4';
  
const Header = () =>  {

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        
        // Add event listener for window resize
        window.addEventListener('resize', () => handleWindowSizeChange());

        // Cleanup the event listener when the component unmounts
        return () => window.removeEventListener('resize', () => handleWindowSizeChange());
    }, []);

    // Update window width state on window resize
    const handleWindowSizeChange = () => {
        setWindowWidth(window.innerWidth);
    };

    // Check if the device is mobile or tablet
    const isMobile = windowWidth <= 769;
    const isTablet = windowWidth <= 1024;

	return (
	  <main style={{marginLeft: 'auto', marginRight: 'auto', paddingTop: '3rem', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', overflow: 'hidden', boxSizing: 'border-box'}}>
        {/* Button */}
        {/* <button style={{fontWeight: "bold", fontSize: '.875rem', color: '#fff', lineHeight: '1.25rem', padding: '.25rem .75rem .25rem .75rem', borderRadius: '50px', border: '1px solid grey', overflow: 'hidden', height: '3rem', marginBottom: '2rem', background: 'transparent', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            Latest update
            <span style={{marginLeft: '5px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <ArrowForwardOutlinedIcon />
            </span>
        </button> */}
        {/* Header + Banners */}
        <div style={{zIndex: 10, width: '100%', textAlign: 'center', paddingLeft: '1rem', paddingRight: '1rem', marginLeft: 'auto', marginRight: 'auto' }}>
            {/* Heading + CTA Buttons */}
            <div style={{marginLeft: 'auto', marginRight: 'auto'}}>
                {/* Title */}
                <h2 style={{fontSize: `${isMobile ? '2.25rem' : '3.75rem'}`, fontWeight: 'bold', marginBottom: '1.5rem', margin: '0'}}>
                    Undetectable Interview AI
                </h2>
                {/* Description */}
                <p style={{fontWeight: 500, fontSize: '1.25rem', color: 'rgb(172,172,172)', textAlign: 'center', marginBottom: '3rem'}}>
                    Interview Cheater is an invisible AI for technical interviews.
                </p>
                {/* CTA Buttons */}
                <div style={{display: 'grid', gridTemplateColumns:`${isMobile ? 'repeat(1, 1fr)' : 'repeat(2, 1fr)'}`, width: '100%', gap: '1rem'}}>
                    {/* Download Buttons */}
                    <DownloadBtn_Apple />
                    <DownloadBtn_Win />
                </div>
            </div>
            {/* Banners */}
            <div style={{marginTop: '2rem', display: 'grid', gridTemplateColumns: `${isMobile ? 'repeat(1, 1fr)' : 'repeat(2, 1fr)'}`, gap: '1.5rem'}}>
                {/* Box */}
                <div style={{width: '100%', borderRadius: '.75rem', overflow: 'hidden'}}>
                    <div style={{color: 'rgb(179,179,179)', fontWeight: 500, fontSize: '1rem', textAlign: 'center', marginBottom: '.5rem'}}>
                        <span style={{color: '#ffff00', textDecoration: 'none', marginRight: '2px'}}>You</span>, screen-sharing on Zoom
                    </div>
                    <div style={{background: 'black', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '.75rem', overflow: 'hidden', position: 'relative'}}>
                        {/* <img style={{width: '100%'}} src="https://support.leetcode.com/hc/article_attachments/360053870693/Screen_Shot_2019-12-12_at_5.28.22_PM.png" /> */}
                        <video className='video banner' muted loop playsInline controlsList='nodownload' disablePictureInPicture disableRemotePlayback autoPlay>
                            <source type='video/mp4' src={demo_1} />
                        </video>
                    </div>
                </div>
                {/* Box */}
                <div style={{width: '100%', borderRadius: '.75rem', overflow: 'hidden'}}>
                    <div style={{color: 'rgb(179,179,179)', fontWeight: 500, fontSize: '1rem', textAlign: 'center', marginBottom: '.5rem'}}>
                        <span style={{color: '#ffff00', textDecoration: 'none', marginRight: '2px'}}>Interviewer</span>, watching your screen
                    </div>
                    <div style={{background: 'black', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '.75rem', overflow: 'hidden', position: 'relative'}}>
                        {/* <img style={{width: '100%'}} src="https://support.leetcode.com/hc/article_attachments/360053870693/Screen_Shot_2019-12-12_at_5.28.22_PM.png" /> */}
                        <video className='video banner' muted loop playsInline controlsList='nodownload' disablePictureInPicture disableRemotePlayback autoPlay>
                            <source type='video/mp4' src={demo_2} />
                        </video>
                    </div>
                </div>
            </div>
        </div>
	  </main>
	);
}
  
export default Header;
  